var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 25.375L13.8 14.4999L0 3.62491L4.6 -0.000101089L23 14.4999L4.6 29L0 25.375Z","fill":"#282727"}));
}

ArrowRight.defaultProps = {"width":"23","height":"29","viewBox":"0 0 23 29","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
